// @ts-nocheck
import React, { useState } from 'react';

interface SocraticQuestionInputProps {
  onSubmit: (answer: string) => Promise<void>;
  disabled: boolean;
  [key: string]: any;
}

// 苏格拉底对话输入组件
const SocraticQuestionInput: React.FC<SocraticQuestionInputProps> = ({ onSubmit, disabled }) => {
  const [answer, setAnswer] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!answer.trim() || disabled) return;

    setIsSubmitting(true);
    await onSubmit(answer);
    setAnswer('');
    setIsSubmitting(false);
  };

  return (
    <div style={{marginTop: '15px'}}>
      <textarea
        value={answer}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setAnswer(e.target.value)}
        placeholder="输入你的思考..."
        disabled={disabled || isSubmitting}
        style={{
          width: '100%',
          minHeight: '80px',
          padding: '10px',
          border: '1px solid #ddd',
          borderRadius: '4px',
          fontSize: '14px',
          resize: 'vertical'
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
          if (e.key === 'Enter' && e.ctrlKey) {
            handleSubmit();
          }
        }}
      />
      <button
        onClick={handleSubmit}
        disabled={!answer.trim() || disabled || isSubmitting}
        style={{
          marginTop: '10px',
          padding: '8px 20px',
          background: (!answer.trim() || disabled || isSubmitting) ? '#ccc' : '#2196F3',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: (!answer.trim() || disabled || isSubmitting) ? 'not-allowed' : 'pointer'
        }}
      >
        {isSubmitting ? '思考中...' : '提交回答 (Ctrl+Enter)'}
      </button>
    </div>
  );
};

export default SocraticQuestionInput;
